import { render } from "./EventsCardShimmer.vue?vue&type=template&id=50ef2dd6"
const script = {}
script.render = render

export default script